import { useSEO } from '@/hooks/useSEO';
import LicenseAgreementText from '@/components/onboarding/LicenseAgreementText';

// ADM-37: In-app software license agreement between the vendor (Admitrix) and
// the client (YuHasPro) — shown only to logged-in staff. This is unrelated to
// the public /terms route (TermsPage.js), which is YuHasPro's own
// customer-facing Terms of Service for their students/parents. The body text
// is shared with the first-run onboarding wizard's acceptance step
// (OnboardingWizard.js) via LicenseAgreementText, so the two never drift.
export default function TermsAndConditionsPage() {
  useSEO({ title: 'Software License Agreement — Admitrix', description: 'Software license agreement between Admitrix and YuHasPro.' });

  return (
    <div data-testid="terms-and-conditions-page" className="stagger-in">
      <div className="mb-6">
        <h1 className="font-display text-3xl font-extrabold text-foreground tracking-tight">Software License Agreement</h1>
        <p className="text-sm text-muted-foreground mt-1">Terms governing YuHasPro&rsquo;s use of the Admitrix CRM software</p>
      </div>
      <div className="max-w-3xl">
        <LicenseAgreementText />
      </div>
    </div>
  );
}
